#assign jQuery to $ since wordpress uses it in no conflict mode
$ = jQuery
$window = $(window)

# exports function globally for use on-page
root = exports ? this

donationAmountEl = $('#amount_other_field');

# minimizes the current slide and shows the one selected for with 'selector'

# show a list of errors (slide down the error div and then slide back up after a little while)
root.showDonateError = (error) ->
  $('.donate-errors').html(error).addClass('show').delay(2000).queue (next) ->
    $(@).removeClass('show').dequeue()

# show a list of errors (slide down the error div and then slide back up after a little while)
root.showDonateErrorLong = (error) ->
  $('.donate-errors').html(error).addClass('show').delay(10000).queue (next) ->
    $(@).removeClass('show').dequeue()

# check if all the correct info is filled out by checking each form selector
personalInfoFilled = ->
  return ($('#name').val() && $('#email').val() && $('#address1').val() && $('#city').val() && $('#state').val() && $('#zip').val())

donateAmountFilled = ->
  return !isNaN(donationAmountEl.val()) && donationAmountEl.val() > 0

ccInfoFilled = ->
  return $('#card_num').val() && $('#card_code').val() && $('#exp_date_month').val() && $('#exp_date_year').val()

donateAmount = ->
  console.log donationAmountEl.val()
  if !isNaN( donationAmountEl.val() ) && donationAmountEl.val() > 0
    console.log 'donation amount in input'
    return donationAmountEl.val()
  else
    console.log 'donatuion amount in radio'
    return $('input[name="amount"]:checked').val()

setDonationAmount = (amt) ->
  donationAmountEl.val amt
  $('.donation-amount').text amt

# click events for donate js driven page-through
# also checks for form completion on each step
# most steps also check to make sure you've filled out a valid donation amt

$(document).on 'click', '#amount_radio_button_other', (e) ->
  donationAmountEl.focus()

$(document).on 'click', 'label.amount', (e) ->
  setDonationAmount $('#' + ($(@).attr 'for')).val()

$(document).on 'click', '#donate-submit', (e) ->
  if !donateAmountFilled()
    showDonateErrorLong('Please enter your donation amount')
  else if !personalInfoFilled()
    showDonateErrorLong('Please enter your billing information')
  else if !ccInfoFilled()
    showDonateErrorLong('Please enter your payment info')
  else if !$('#act').parsley().validate()
    e.preventDefault()
    showDonateErrorLong('Error: please make sure that all your information is correct')
    ga 'send', 'event',
      'eventCategory' : 'Donation'
      'eventAction'   : 'Failed Donation Submission'
  else #successfully submitted
    fbq 'track', 'Purchase', { value: donateAmount(), currency: 'USD' }
    ga 'send', 'event',
      'eventCategory' : 'Donation'
      'eventAction'   : 'Donation Submission'
      'value'         : donateAmount()

$(document).on 'change', '#amount_other_field', (e) ->
  $('#amount_radio_button_other').prop 'checked', true
  console.log $(@)
  setDonationAmount $(@).val()

$('.paypal').on 'click', ->
  ga 'send', 'event',
    'eventCategory' : 'Donation'
    'eventAction'   : 'PayPal Donation Button Clicked'

$('#donateNow').on 'click', ->
  $('html, body').animate({
    scrollTop: ($("#donate").offset().top - 60)
  }, 750, 'swing');


$ ->
  if !donationInformationFilled
    if $('#amount_radio_button_5').length
      $('#amount_radio_button_5').prop 'checked', true
      setDonationAmount 5
    else if $('#amount_radio_button_25').length
      $('#amount_radio_button_25').prop 'checked', true
      setDonationAmount 25
    else if $('#amount_radio_button_50').length
      $('#amount_radio_button_50').prop 'checked', true
      setDonationAmount 50
